import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCardioRespAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitCardioRespResultInput;
}>;


export type CreateCardioRespAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitCardioRespResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitCardioRespResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & CardioRespAssessmentResultFragment
    )> }
  ) }
);

export type CardioRespAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: (
    { __typename: 'CardioRespResult' }
    & CardioRespAssessmentResultDataFragment
  ) | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type CardioRespAssessmentResultDataFragment = (
  { __typename: 'CardioRespResult' }
  & Pick<SchemaTypes.CardioRespResult, 'vo2Max' | 'restingHR' | 'exerciseHR' | 'hrvMs'>
);

export const CardioRespAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CardioRespAssessmentResultData on CardioRespResult {
  vo2Max
  restingHR
  exerciseHR
  hrvMs
}
    `;
export const CardioRespAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment CardioRespAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on CardioRespResult {
      ...CardioRespAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const CreateCardioRespAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation CreateCardioRespAssessmentResult($input: SubmitCardioRespResultInput!) {
  submitCardioRespResult(input: $input) {
    __typename
    ... on SubmitCardioRespResultSuccessfulResponse {
      result {
        ...CardioRespAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${CardioRespAssessmentResultFragmentDoc}
${CardioRespAssessmentResultDataFragmentDoc}`;
export type CreateCardioRespAssessmentResultMutationFn = Apollo.MutationFunction<CreateCardioRespAssessmentResultMutation, CreateCardioRespAssessmentResultMutationVariables>;

/**
 * __useCreateCardioRespAssessmentResultMutation__
 *
 * To run a mutation, you first call `useCreateCardioRespAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardioRespAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardioRespAssessmentResultMutation, { data, loading, error }] = useCreateCardioRespAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardioRespAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardioRespAssessmentResultMutation, CreateCardioRespAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardioRespAssessmentResultMutation, CreateCardioRespAssessmentResultMutationVariables>(CreateCardioRespAssessmentResultDocument, options);
      }
export type CreateCardioRespAssessmentResultMutationHookResult = ReturnType<typeof useCreateCardioRespAssessmentResultMutation>;
export type CreateCardioRespAssessmentResultMutationResult = Apollo.MutationResult<CreateCardioRespAssessmentResultMutation>;
export type CreateCardioRespAssessmentResultMutationOptions = Apollo.BaseMutationOptions<CreateCardioRespAssessmentResultMutation, CreateCardioRespAssessmentResultMutationVariables>;